import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Box,
} from '@mui/material';
import useGetLengthCheckerProducts from './hooks/useGetLengthCheckerProducts';

function ProductsModal({ open, lengthId, onClose }) {
  const { products, loading, fetchProducts } = useGetLengthCheckerProducts();

  useEffect(() => {
    if (open && lengthId) {
      fetchProducts(lengthId);
    }
  }, [open, lengthId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Products - Length ID: {lengthId}</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" padding={2}>
            <CircularProgress />
          </Box>
        ) : products && products.length > 0 ? (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Product</TableCell>
                <TableCell>Product Length</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {products.map(product => (
                <TableRow key={product.productId}>
                  <TableCell>{product.product}</TableCell>
                  <TableCell>{product.productLength}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Box padding={2}>No products found</Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ProductsModal;
